import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/site/ui";
import { useFetch } from "@/lib/useFetch";
import { ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/seo";

export default function Resources() {
    const { data: posts } = useFetch("/blog", []);
    useSeo({ title: "Resources & Blog — Digital Growth Tips for Small Business | SUDIGI", description: "Practical articles on SEO, Google Business, social media, reels and small business growth." });
    return (
        <section className="bg-teal-900 py-16 min-h-[70vh]">
            <div className="container-x">
                <div className="mb-12 text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Resource Center" title="Digital Growth Tips & Guides" subtitle="Practical, jargon-free advice to help your business grow online." />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {(posts || []).map((p) => (
                        <Link key={p.slug} to={`/resources/${p.slug}`} className="card-teal rounded-2xl overflow-hidden group" data-testid={`blog-${p.slug}`}>
                            <div className="p-6">
                                <span className="text-xs font-semibold text-gold uppercase tracking-wide">{p.category}</span>
                                <h3 className="mt-2 font-bold text-cream text-lg leading-snug">{p.title}</h3>
                                <p className="mt-2 text-sm text-cream-soft">{p.excerpt}</p>
                                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-gold group-hover:gap-2 transition-all">Read more <ArrowRight className="w-4 h-4" /></span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
